import { SVGIconComponent } from './types';

export const DeliveredStatusCircle: SVGIconComponent = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Status-indicator/delivered" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill="#0A4586" cx="7" cy="7" r="7"></circle>
    </g>
  </svg>
);
